<!--
REMESSA E RETORNO CNAB



TITULOS COM REMESSA PENDENTE:
/fin/cnab/ar/pendencia/    -> lista de contas com titulos pendentes para remessa

REMESSAS GERADAS:
/fin/cnab/ar/remessa/      -> lista de remessas geradas
/fin/cnab/ar/remessa/      -> [POST] geracao da remessa
/fin/cnab/ar/remessa/id    -> download do arquivo

RETORNO:
/fin/cnab/ar/retorno/      -> [POST] upload do retorno
/fin/cnab/ar/retorno/      -> retornos importados






-->

<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Cnab from './receber-list-cnab.vue'
import CustomerForm from './customer-form'
import FinanceiroForm from './financeiro-form'
import { apiDownload, apiDownloadPDF, apiORDSpost, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { SysVars } from '../main';

export default {
    data () {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            operacao: {},

            tabs: [{ title: 'Gerar Remessa'}, { title: 'Arquivos de Remessa Gerados' }, { title: 'Arquivos de Retorno Importados' }, { title: 'Entradas Rejeitadas' }, { title: 'Títulos Sem Conta Vinculada', count: null }],
            activeTab: 0,

            errmessages: [],

            url: '',
            urlsemvinculo: 'cnab/ar/vincularconta/',
            urldesvincular: 'cnab/ar/desvincularconta/',
            urlpendente: 'cnab/ar/pendencia/',
            urlremessa: 'cnab/ar/remessa/',
            urlexcluirremessa: 'cnab/ar/excluirremessa/',
            urlrej: 'cnab/ar/rejeitados/',
            urlretorno: 'cnab/ar/retorno/',

            showDetalhesRetorno: false,
            dadosRetorno: {},
            cnabErrors: [],

            contaSelecionada: null,
            showModalErros: false,
            showModalTitulosRemessa: false,
            titulos: [],
            retornoImportadosItem: {},

            titulosCheckAll: false,

            crud: SysVars.crudU,
            showFormPart: false,
            codpart: null,

            showFormFin: false,
            codfin: null,

            confirmaExcluirRemessa: false,
            codcnabExcluir: null,
            messageExcluir: 'Os títulos desta remessa ficarão disponíveis para nova geração de remessa. Confirma a exclusão desta remessa?',
            titleExcluir: 'Excluir Remessa',

        }
    },
    computed: {
        contasconfiguradas: function () {
            if (this.$store.getters.getCnabPendente[0])
                return this.$store.getters.getCnabPendente[0].contasconfiguradas
            else
                return 0
        },
        cnabSemVinculo: function () {
            return this.$store.getters.getCnabSemVinculo
       },
        totalCnabSemVinculo: function () {
            return this.cnabSemVinculo && this.cnabSemVinculo.length
                ? this.cnabSemVinculo.reduce((a, b) => a + b.vlr, 0)
                : 0
        },
        totalCnabSemVinculoChecked: function () {
            return this.cnabSemVinculo && this.cnabSemVinculo.length
                ? this.cnabSemVinculo.filter(el => el.isChecked === true)
                    .reduce((total, current) => total + current.vlr, 0)
                : 0
        },
        cnabPendente: function () {
            if (this.$store.getters.getCnabPendente[0])
                return this.$store.getters.getCnabPendente[0].contas
            else
                return []
        },
        cnabRemList: function () {
            return this.$store.getters.getCnabRemList
        },
        cnabRetList: function () {
            return this.$store.getters.getCnabRetList
        },
        cnabRetDet: function () {
            if (this.$store.getters.getCnabRetDetList.length && this.$store.getters.getCnabRetDetList[0])
              return this.$store.getters.getCnabRetDetList[0]
            else
              return {}
          },
        cnabRetDetList: function () {
            if (this.$store.getters.getCnabRetDetList.length && this.$store.getters.getCnabRetDetList[0].detalhes) {
                return this.$store.getters.getCnabRetDetList[0].detalhes
            } else {
                return []
            }
        },
        cnabRetDetmessages: function () {
            if (this.$store.getters.getCnabRetDetList.length) {
                return this.$store.getters.getCnabRetDetList[0].messages
            } else {
                return null
            }
        },
        cnabRejList: function () {
            return this.$store.getters.getCnabRejList
        },
    },

    watch: {
        titulosCheckAll() {
            if (this.titulosCheckAll) {
                this.cnabSemVinculo.forEach(titulo => {
                    this.$set(titulo, 'isChecked', true)
                })
            } else {
                this.cnabSemVinculo.forEach(titulo => {
                    this.$set(titulo, 'isChecked', false)
                })
            }
        },
    },

    methods: {

        closeFormFin () {
            this.showFormFin = false
            this.codfin = null
            this.loadData()
        },

        handleEditFin (id) {
            this.codfin = id
            this.crud = SysVars.crudU
            this.showFormFin = true
        },

        closeFormPart () {
            this.showFormPart = false
            this.codpart = null
            this.loadData()
        },


        editPart (tipo, codpart) {
            //abre a tela de edicao
            if (tipo == 'part'){
              this.crud = SysVars.crudU //update
              this.codpart = codpart
              this.showFormPart = true;
            }
        },


        changeTab (idx) {
            //mudança de pagina
            this.activeTab = idx
            this.loadData()
        },

        handleRemoverTituloRemessa(item){
            let sendData = {
              titulos: []
              }

            if (item){
              sendData.titulos.push({codfin: item.codfin})
            }else{
              if (this.titulos){
                  this.titulos.forEach((tit, index)=>{
                      console.log(tit)
                      if (tit.isChecked){
                        sendData.titulos.push({codfin: tit.codfin})
                      }
                  })
              }

            }

            let self = this;
                apiORDSpost(this.$store, this.urldesvincular, sendData, 'post').then(
                () => {
                    self.$erpToastSuccess('Título desvinculado com sucesso!')
                    self.closeModalTitulosRemessa();

                    self.changeTab('1');

                }
                )

            },

        handleCloseMessage() {
            this.confirmaExcluirRemessa = false
        },

        handleConfirmaExcluirRemessa (codcnab) {
            this.confirmaExcluirRemessa = true
            this.codcnabExcluir = codcnab
        },

        handleExcluirRemessa(){
            this.confirmaExcluirRemessa = false
            let sendData = {
              remessa: this.codcnabExcluir
            }

            let self = this;
            apiORDSpost(this.$store, this.urlexcluirremessa, sendData, 'post').then(
             () => {
                 self.$erpToastSuccess('Remessa excluída com sucesso!')
                 self.changeTab('1');
               }
            )

        },

        handleShowTitulos(cta){
            this.titulos = cta.titulos

            if (this.titulos){
                this.titulos.forEach((fin, index)=>{
                    this.$set(this.titulos[index], 'isChecked', false);
                })
            }

            this.showModalTitulosRemessa = true
        },

        handleConfigurarConta() {
            this.$router.push('/cta')
        },

        handleDownloadRemessa(codcnab) {
            //DOWNLOAD DO ARQUIVO DE REMESSA
            apiDownload(this, this.urlremessa + codcnab, null, 'get')
        },

        someCtaChecked() {
            return this.cnabSemVinculo
                .some(cta => cta.hasOwnProperty('isChecked') && cta.isChecked === true)

        },

        showSelectVincularConta() {
            if (this.someCtaChecked()) {
                jQuery('[data-toggle="collapse"]').collapse('show')
            } else {
                jQuery('[data-toggle="collapse"]').collapse('hide')
            }
        },

        handleVincular() {
            const titulosMarcados = this.cnabSemVinculo.filter((obj) => {
                return obj.isChecked == true
            })

            if (!titulosMarcados) {
                this.$erpToastError('É necessário selecionar pelo menos um título.')
                return
            }

            if (!this.contaSelecionada) {
                this.$erpToastError('É necessário selecionar uma conta.')
                return
            }

            let data = []

            titulosMarcados.map(titulo => {
                data.push({
                    conta: this.contaSelecionada,
                    codfin: titulo.codfin,
                })
            })

            const sendData = { titulos: data }
            this.handleGravarVinculo(sendData)
        },

        handleGravarVinculo(sendData) {
            if (!sendData) {
                this.$erpToastError('Não há dados a serem gravados.')
                return
            }

            apiORDSpost(this.$store, this.urlsemvinculo, sendData, 'post')

            this.$erpToastSuccess('Título(s) vinculado(s) com sucesso!')

            this.loadData()
        },

        async handleGerarRemessa(obj) {
            //GERACAO DO ARQUIVO DE REMESSA PARA A CONTA SELECIONADA
            let sendData = {
                cnab: { codcta: obj.codcta }
            }
            this.$set(obj, 'errmessages', null)
            this.$set(obj, 'errtitulos', null)
            //DEPOIS DE GERADO SERÁ FEITO O DOWNLOAD DO ARQUIVO

            const data = await apiORDSpost(this.$store, this.urlremessa, sendData, 'post')
            if (data.errmessages) {
                // this.$set(obj, 'errmessages', data.errmessages)
                obj.errmessages = data.errmessages
                this.$erpToastError('Ocorreu erro ao gerar arquivo de remessa.')
                return
            }
            else
            if (data.titulos) {
              obj.errtitulos = data.titulos
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
              return
            } else {
                let codcnab = data.codcnab
                apiDownload(this, this.urlremessa + codcnab, null, 'get')
                this.$erpToastSuccess('Arquivo gerado')
            }
            this.loadData()
        },

        handleImportarRetorno() {
            //SELECIONA ARQUIVO DE RETORNO
            this.errmessages = []
            this.$refs.retFile.value = ''
            this.$refs.retFile.click()
        },

        handleUploadRetorno () {
            //ENVIA O ARQUIVO DE RETORNO SELECIONADO
            var files = this.$refs.retFile.files
            if (files.length == 0) {
               return
            }

            var self = this

            let file = files[0]
            let formData = new FormData()
            formData.append(file.name, file)
            axios.post(urlORDS(this.$store, this.urlretorno), formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'filename': file.name
                }
            }
            ).then(function(response){
                    if (response.data.errmessages) {
                       self.errmessages = response.data.errmessages
                    } else {
                        // console.log(response);
                        let data = response.data
                        console.log(data)
                        self.$erpToastSuccess('O arquivo foi importado.')
                        self.activeTab = 2
                        self.loadData()
                        if (data){
                          self.handleDetalhesRetorno(data);
                        }
                    }
                })
        },

        handleAction (act, codnf) {

        },

        handleExportRetorno () {
            //EXPORTA REGISTROS DO RETORNO PARA PLANILHA
            const data = this.cnabRetDetList.map(det => ({
                data: formatDate(det.dtoco),
                ocorrencia: det.ocorrencia,
                doc: det.doc,
                nome: det.par_nome,
                motivo: det.motivo,
                tarifa: formatValue(det.vtarifa,2)
            }))
            const csv = objectToCsv(data)
            downloadCsvReport(csv)
        },

        handleExportRejeitados () {
            //EXPORTA TITULOS REJEITADOS PLANILHA
            const data = this.cnabRejList.map(det => ({
                data: formatDate(det.dtremessa),
                tipo: this.textSTREMESSA(det.stremessacnab),
                doc: det.doc,
                nome: det.part_nome,
                motivo: det.motivo,
                arquivo_retorno: det.ret_filename
            }))
            const csv = objectToCsv(data)
            downloadCsvReport(csv)
        },

        viewErrors(item) {
            const erros = JSON.parse(item.erros)
            this.retornoImportadosItem.errors = erros.errmessages
            this.retornoImportadosItem.filename = item.filename
            this.showModalErros = true
        },

        closeModalErros() {
            this.showModalErros = false
        },

        closeModalTitulosRemessa() {
            this.showModalTitulosRemessa = false

          },

        handleActionBarList (act) {
            // if (act == 0) {
            //     //efetua download dos xmls de nfe no periodo selecionado
            //     var data = { datareferencia: this.monthFilter.startDate }
            //     apiDownload(this, 'print/xmlfiles/', data, 'post')
            // }
            // if (act == 1) {
            //     //efetua importacao do xml de nf-e
            //     this.handleImportarRetorno()
            // }
            // if (act == 2) {
            //     //exportar a lista de notas para planilha
            //     const data = this.nfList.map(nf => ({
            //         data: this.data(nf.data),
            //         serie: nf.serie,
            //         numeronf: nf.nf,
            //         operacao: this.operacaoNf(nf.operacaonf),
            //         natureza: nf.descricao,
            //         nome: nf.nome,
            //         total: formatValue(nf.totger,2)
            //     }))
            //     const csv = objectToCsv(data)
            //     downloadCsvReport(csv)
            // }

        },

        closeForm() {

        },

        handleSearch(value) {
            //efetua a pesquisa
            //this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"nf":{"$eq":"' + value + '"}}]}'
            this.loadData()
        },

        async handleDetalhesRetorno(retorno) {
            //EXIBE OS REGISTROS DE DETALHES DO RETORNO CNAB
            this.errmessages = []
            this.cnabErrors = []
            this.dadosRetorno = retorno
            await this.$store.dispatch('loadCnabRetDetList', { id: retorno.codcnab })
            this.showDetalhesRetorno = true

            // console.log(this.$store.getters.getCnabRetDetList)

            if (this.cnabRetDet){
                this.dadosRetorno = this.cnabRetDet
                
                // Carrega erros de identificação salvos na nova coluna CLOB do banco
                if (this.cnabRetDet.erros_identificacao) {
                    try {
                        this.cnabErrors = JSON.parse(this.cnabRetDet.erros_identificacao)
                    } catch(e) {
                        console.error('Erro ao processar erros_identificacao:', e)
                        this.cnabErrors = []
                    }
                }
              }

            if (this.cnabRetDetmessages) {  //exibe a lista de erros encontrados no arquivo
                let err = JSON.parse(this.cnabRetDetmessages)
                this.errmessages = err.errmessages
            }
        },

        closeDetalhesRetorno() {
            //FECHA TELA DE DETALHES DO RETORNO
            this.showDetalhesRetorno = false
            this.cnabErrors = []
        },

        loadData() {
            if (this.activeTab == '0') {
                this.$store.dispatch('loadCnabPendente')
            }
            if (this.activeTab == '1') {
                this.$store.dispatch('loadCnabRemList')
            }
            if (this.activeTab == '2') {
                this.$store.dispatch('loadCnabRetList')
            }
            if (this.activeTab == '3') {
                this.$store.dispatch('loadCnabRejList')
            }

            this.$store.dispatch('loadCnabSemVinculo')

            setTimeout(() => {
                this.tabs[4].count = this.cnabSemVinculo.length
            }, 1000);

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        textSTREMESSA (value) {
            return getText(value, this.metadata.fin.stremessacnab)
        },

    },

    components: {
        BarList, BarGrid, FilterList, Cnab, CustomerForm, FinanceiroForm,
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div>
            <!-- <bar-list
                :refresh-button="true"
                single-entity="Cobrança Bancária"
                plural-entity="Cobrança Bancária"
                :moreActions="moreActionsBarList"
                @action="handleActionBarList"
                @search="handleSearch"
                @refresh="loadData">
            </bar-list> -->

            <div class="row">
                <div class="col-md-3 col-12 float-left">
                    <h4 class="def-title">Cobrança Bancaria</h4>
                </div>
            </div>

            <div>
                <br>
                <div class="row col">
                    <v-button label="Importar Arquivo de Retorno" title="" :nb-btdef="true" @click="handleImportarRetorno()"></v-button>
                </div>
                <!-- <br> -->
                <!-- <alert v-if="errmessages.length > 0" type="error" title="Erro no envio do arquivo de retorno" :messages="errmessages"></alert> -->
                <br>
                <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

                <div v-if="activeTab == '0'">
                    <div class="row nb-margin-topbottom" v-if="contasconfiguradas == 0">
                        <div class="col-md-12 text-center">
                            <label-title title="Nenhuma conta foi configurada para emissão de boletos"></label-title><br>
                        </div>
                        <div class="col-md-12 text-center">
                            <span class="lbl-edit">Configure agora uma conta bancária para emissão de boletos e envio de arquivos de cobranças para o banco</span>
                        </div>
                        <div class="col-md-12 text-center nb-margin-topbottom">
                            <v-button label="Configurar Agora as Contas Bancárias" :nb-btdef="true" @click="handleConfigurarConta()"></v-button>
                        </div>
                    </div>
                    <alert v-if="contasconfiguradas > 0 && !cnabPendente.length" type="warning" text="Não há títulos disponíveis para gerar arquivo de remessa"></alert>

                    <div class="mainbox" v-for="cta in cnabPendente" :key="cta.codcta">
                        <div class="mark-gray"></div>
                        <div class="box p-2">
                            <div class="row">
                                <div class="col-md-4 col-9">
                                    <img :src="cta.banco_url" style="padding: 10px; height: 55px">
                                    <span class="lbl-title-produto">{{ cta.descricao }}</span><br>
                                </div>
                                <div v-if="cta.qt > 0" class="col-md-2 col-2">
                                    <label class="lbl-list w-100">Quantidade de Documentos</label>
                                    <span class="data-list">{{ cta.qt }}</span>
                                </div>
                                <div v-if="cta.qt > 0" class="col-md-2 col-3">
                                    <label class="lbl-list w-100">Valor Total</label>
                                    <span class="data-list">{{ cta.vlr | formatValue(2) }}</span>
                                </div>
                                <div class="col-md-4 col-3 ml-auto d-flex" v-if="cta.qt > 0">
                                    <v-button label="Ver Titulos Desta Remessa" title="" :nb-btdef="false" @click="handleShowTitulos(cta)"></v-button>
                                    <v-button label="Gerar Remessa Deste Banco" title="" :nb-btdef="true" @click="handleGerarRemessa(cta)"></v-button>
                                </div>
                                <div class="col-md-12 col-12" v-if="cta.errmessages && cta.errmessages.length > 0">
                                    <alert type="error" title="Ocorreu erro na geração do arquivo" :messages="cta.errmessages"></alert>
                                </div>
                                <div class="col-md-12 col-12" v-if="cta.errtitulos && cta.errtitulos.length > 0">
                                    <alert type="error" title="Alguns erros precisam ser corrigidos:" @edit="editPart" :messages="cta.errtitulos"></alert>
                                </div>
                            </div>
                            <div class="row" v-if="cta.qt == 0">
                                <div class="col">
                                    <span class="data-list">Nenhum título pendente para esta conta</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="activeTab == '1'">
                    <alert v-if="!cnabRemList.length" type="warning" text="Não há arquivos disponíveis para envio"></alert>

                    <div class="mainbox" v-for="(item, index) in cnabRemList" :key="index">
                        <div class="mark-gray"></div>
                        <div class="box">
                            <div class="row p-2">
                                <div class="col-md-4 col-4">
                                    <img :src="item.banco_url" style="padding: 10px; height: 55px">
                                    <span class="lbl-title-produto">{{ item.descricao }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list w-100">Gerado Em</label>
                                    <span class="data-list">{{ item.data | formatDataHora }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list w-100">Nr da Remessa</label>
                                    <span class="data-list">{{ item.numbordero }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list w-100">Quantidade Documentos</label>
                                    <span class="data-list">{{ item.qt }}</span>
                                </div>
                                <div class="col-md-2 col-3">
                                    <label class="lbl-list w-100">Valor Total</label>
                                    <span class="data-list">{{ item.vlr | formatValue(2) }}</span>
                                </div>
                                <div class="col-md-12 col-12">
                                    <v-button label="Download do Arquivo" title="" :nb-btdef="true" @click="handleDownloadRemessa(item.codcnab)"></v-button>
                                    <v-button label="Excluir Remessa" title="" :nb-btdef="false" @click="handleConfirmaExcluirRemessa(item.codcnab)"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="activeTab == '2'">
                    <alert v-if="!cnabRetList.length" type="warning" text="Nenhum arquivo de retorno foi encontrado"></alert>

                    <div class="mainbox" v-for="(item, index) in cnabRetList" :key="index">
                        <div :class="[{ 'mark-red': item.qtrej > 0 || item.qterros > 0 }, { 'mark-green': item.qtrej == 0 || item.qterros == 0 }]"></div>
                        <div class="box">
                            <div class="row p-2">
                                <div class="col-md-12 col-12">
                                    <!-- <label class="lbl-list">Conta</label> -->
                                    <img :src="item.banco_url" style="padding: 10px; height: 55px">
                                    <span class="lbl-title-produto">{{ item.descricao }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list">Importado Em</label>
                                    <span class="data-list">{{ item.data | formatDataHora }}</span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Confirmados</label><br>
                                    <span class="data-list">{{ item.qt }}</span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Liquidações</label><br>
                                    <span class="data-list">{{ item.qtliq }}</span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Baixas</label><br>
                                    <span class="data-list">{{ item.qtbai }}</span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Erros</label><br>
                                    <i class="fa fa-search text-secondary" title="Ver detalhes" style="cursor: pointer;"
                                        @click="viewErrors(item)" v-if="item.qterros > 0"></i>
                                    <span class="data-list">{{ item.qterros }}</span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Rejeições</label><br>
                                    <span class="data-list">{{ item.qtrej }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list">Arquivo</label><br>
                                    <span class="data-list">{{ item.filename }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <v-button title="Ver detalhes do arquivo" icon="fa-search" @click="handleDetalhesRetorno(item)"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TITULOS REJEITADOS -->
                <div v-if="activeTab == '3'">
                    <alert v-if="!cnabRejList.length" type="warning" text="Não existem títulos rejeitados"></alert>

                    <div  v-if="cnabRejList.length > 0" class="row">
                        <div class="col-md-12 col-12 nb-margin-bottom">
                            <v-button title="Exportar Para Planilha" icon="fa-download" @click="handleExportRejeitados()"></v-button>
                        </div>
                    </div>

                    <div class="mainbox" v-for="(item, index) in cnabRejList" :key="index">
                        <div class="mark-red"></div>
                        <div class="box">
                            <div class="row p-2">
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list">Data da Remessa</label><br>
                                    <span class="data-list">{{ item.dtremessa | formatData }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list">Nome do Cliente</label><br>
                                    <span class="data-list">{{ item.part_nome }}</span>
                                </div>
                                <div class="col-md-2 col-2">
                                    <label class="lbl-list">Tipo de Erro</label><br>
                                    <span class="data-list">{{ textSTREMESSA(item.stremessacnab) }}</span>
                                </div>
                                <div class="col-md-3 col-2">
                                    <label class="lbl-list">Motivo</label><br>
                                    <span class="data-list">{{ item.motivo }}</span>
                                    <div v-if="item.ret_filename">
                                        <span class="lbl-list-sm">Arq. Retorno: </span><span class="data-list-sm">{{ item.ret_filename }} ({{ item.ret_dtimportacao | formatData }})</span>
                                    </div>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Documento</label><br>
                                    <span class="data-list">{{ item.doc }}<span v-if="item.parcela">/{{ item.parcela }}</span></span>
                                </div>
                                <div class="col-md-1 col-2">
                                    <label class="lbl-list">Ações</label><br>
                                    <v-button title="Consultar/Editar Título" icon="fa-search" @click="handleEditFin(item.codfin)"></v-button>
                                </div>
                                <!-- <div class="col-md-2 col-2">
                                    <v-button title="Ver detalhes do arquivo" icon="fa-search" @click="handleDownloadRemessa(item.codcnab)"></v-button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="activeTab == '4'">
                    <div class="col-md-12 mt-2">
                        <div class="d-flex justify-content-start align-items-center bg-white p-2">
                            <div class="col-md-3 text-center">
                                <div class="lbl-edit">
                                    Total Títulos Não Vinculados
                                </div>
                                <div class="total">
                                    R$ <strong>{{ totalCnabSemVinculo | formatValue(2) }}</strong>
                                </div>
                            </div>
                            <div class="col-md-3 text-center">
                                <div class="lbl-edit">
                                    Total Títulos Marcados
                                </div>
                                <div class="total">
                                    R$ <strong>{{ totalCnabSemVinculoChecked | formatValue(2) }}</strong>
                                </div>
                            </div>
                            <!-- <button class="btn nb-btdef mr-1" type="button" data-toggle="collapse" data-target="#multiCollapseExample1"
                                aria-expanded="false" aria-controls="multiCollapseExample1">Vincular</button> -->
                        </div>
                        <div class="collapse multi-collapse" data-toggle="collapse" id="multiCollapseExample1">
                            <div class="card card-body border-0">
                                <div class="d-flex align-items-center">
                                    <form-field v-model="contaSelecionada" label="Selecione uma conta" type="select2" col="3"
                                        :metadata="metadata.fin.codcta" v-validate="metadata.fin.codcta.validator"></form-field>
                                    <button class="btn nb-btdef" @click="handleVincular">Confirmar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="activeTab == '4'">
                    <input-checkbox
                        v-model="titulosCheckAll"
                        :value-checked="true"
                        :value-unchecked="false"
                        label="Marcar/Desmarcar todos"
                    >
                    </input-checkbox>

                    <div class="mainbox" v-for="cta in cnabSemVinculo" :key="cta.codcta">
                        <Cnab :cta="cta" @change="showSelectVincularConta" />
                    </div>
                </div>
            </div>
        </div>

        <md-message v-if="confirmaExcluirRemessa" :message="messageExcluir" :title="titleExcluir" @confirm="handleExcluirRemessa()" @close="handleCloseMessage()"></md-message>

        <!-- INPUT PARA IMPORTACAO DO RETORNO -->
        <div v-show="false" class="row">
            <input type="file" ref="retFile" accept=".txt;*.ret" @change="handleUploadRetorno()">
        </div>

        <!------------------------------------------------------------------------------------
            DETALHES DO ARQUIVO DE RETORNO
        -------------------------------------------------------------------------------------->
        <div v-if="showDetalhesRetorno">
            <div class="nb-modal-scrollable">
                <div class="container nb-modal-scrollable-container">
                    <div class="nb-modal-header">
                        <h4 class="def-title"> Detalhes do Retorno </h4>
                        <button type="button" class="close" @click="closeDetalhesRetorno()" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div id="mymodal" class="nb-modal-scrollable-body">
                        <div class="row nb-margin-bottom">
                            <div class="col-auto">
                                <img :src="dadosRetorno.banco_url" style="padding: 10px; height: 55px">
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">Data da Importação</label>
                                <span class="data-list">{{ dadosRetorno.data | formatDataHora }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <label class="lbl-list">Quantidade</label><br>
                                <span class="data-list">{{ dadosRetorno.qt }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <label class="lbl-list">Liquidações</label><br>
                                <span class="data-list">{{ dadosRetorno.qtliq }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <label class="lbl-list">Baixas</label><br>
                                <span class="data-list">{{ dadosRetorno.qtbai }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <label class="lbl-list">Erros</label><br>
                                <span class="data-list">{{ dadosRetorno.qterros }}</span>
                            </div>
                            <div class="col-md-1 col-3">
                                <label class="lbl-list">Rejeições</label><br>
                                <span class="data-list">{{ dadosRetorno.qtrej }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">Nome do Arquivo</label><br>
                                <span class="data-list">{{ dadosRetorno.filename }}</span>
                            </div>
                        </div>
                        <hr>
                        <validation v-if="errmessages.length != 0" :messages="errmessages"></validation>
                        <alert v-if="cnabRetDetList.length == 0 && cnabErrors.length == 0" type="warning" title="Nenhum título foi localizado no retorno"></alert>
                        <label-title v-if="cnabRetDetList.length > 0" title="Lista dos Titulos Retornados"></label-title>
                        <div  v-if="cnabRejList.length > 0" class="row">
                            <div class="col-md-12 col-12 nb-margin-bottom">
                                <v-button title="Exportar Para Planilha" icon="fa-download" @click="handleExportRetorno()"></v-button>
                            </div>
                        </div>
                        <div class="mainbox">
                            <div class="box" v-for="(item, index) in cnabRetDetList" :key="index">
                                <div class="row">
                                    <div class="col-md-2 col-2">
                                        <label class="lbl-list">Data</label><br>
                                        <span class="data-list">{{ item.dtoco | formatData }}</span>
                                    </div>
                                    <div class="col-md-2 col-2">
                                        <label class="lbl-list">Ocorrência</label><br>
                                        <span class="badge" :class="[{ 'badge-red': (item.tipoococnab == '1') }, { 'badge-green': (item.tipoococnab == '5') }, { 'badge-red': (item.tipoococnab == '7') }, {'badge-blue': (item.tipoococnab == '8')} ]">{{ item.ocorrencia }}</span>
                                    </div>
                                    <div class="col-md-1 col-2">
                                        <label class="lbl-list">Documento</label><br>
                                        <span class="data-list">{{ item.doc }}<span v-if="item.parcela">/{{ item.parcela }}</span></span>
                                    </div>
                                    <div class="col-md-1 col-3">
                                        <label class="lbl-list">Valor Tarifa</label><br>
                                        <span class="data-list">{{ item.vtarifa | formatValue(2) }}</span>
                                    </div>
                                    <div class="col-md-1 col-3">
                                        <label class="lbl-list">Valor Pago</label><br>
                                        <span class="data-list">{{ item.vpago | formatValue(2) }}</span>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <label class="lbl-list">Nome do Cliente</label><br>
                                        <span class="data-list">{{ item.part_nome }}</span>
                                    </div>
                                    <div class="col-md-1 col-2">
                                        <label class="lbl-list">Ações</label><br>
                                        <v-button title="Consultar/Editar Título" icon="fa-search" @click="handleEditFin(item.codfin)"></v-button>
                                    </div>
                                    <div class="col-md-12 col-12" v-if="item.motivos.length">
                                        <label class="lbl-list">Motivo</label>
                                        <span class="error" v-for="(motivo, index2) in item.motivos" :key="index2">{{ motivo.descricao }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Nova seção de erros de identificação -->
                        <div v-if="cnabErrors.length > 0">
                            <hr>
                            <label-title title="Títulos com Erros de Identificação (Não localizados no sistema)"></label-title>
                            <div class="mainbox">
                                <div class="box" v-for="(item, index) in cnabErrors" :key="'err-'+index">
                                    <div class="row">
                                        <div class="col-md-2 col-2">
                                            <label class="lbl-list">Data</label><br>
                                            <span class="data-list">{{ item.dtoco | formatData }}</span>
                                        </div>
                                        <div class="col-md-3 col-3">
                                            <label class="lbl-list">Ocorrência</label><br>
                                            <span class="badge badge-red">NÃO ENCONTRADO: {{ item.des_oco }}</span>
                                        </div>
                                        <div class="col-md-2 col-2">
                                            <label class="lbl-list">Nosso Número</label><br>
                                            <span class="data-list">{{ item.nosso_numero }}</span>
                                        </div>
                                        <div class="col-md-1 col-2" v-if="item.vlr">
                                            <label class="lbl-list">Vlr. Título</label><br>
                                            <span class="data-list">{{ item.vlr | formatValue(2) }}</span>
                                        </div>
                                        <div class="col-md-1 col-2" v-if="item.vtarifa">
                                            <label class="lbl-list">Tarifa</label><br>
                                            <span class="data-list">{{ item.vtarifa | formatValue(2) }}</span>
                                        </div>
                                        <div class="col-md-1 col-2" v-if="item.vpago">
                                            <label class="lbl-list">Vlr. Pago</label><br>
                                            <span class="data-list">{{ item.vpago | formatValue(2) }}</span>
                                        </div>
                                        <div class="col-md-12 col-12" v-if="item.motivos && item.motivos.length">
                                            <label class="lbl-list">Motivos da Rejeição / Ocorrência</label>
                                            <span class="error" v-for="(motivo, index2) in item.motivos" :key="index2">{{ motivo }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box">
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL ERROS RETORNO ARQUIVOS IMPORTADOS -->
        <div class="nb-modal-scrollable" v-if="showModalErros">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Erros Arquivo {{ retornoImportadosItem.filename }}</h5>
                    <button type="button" class="close" @click="closeModalErros" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="row d-flex flex-column mb-3">
                        <div class="container" v-for="erro in retornoImportadosItem.errors" :key="erro.id">
                            {{ erro }}
                        </div>
                    </div>
                    <div class="nb-modal-scrollable-footer">
                        <v-button ref="btnClose" label="Fechar" title="" @click="closeModalErros"></v-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL TITULOS REMESSA -->
        <div class="nb-modal-scrollable" v-if="showModalTitulosRemessa">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Titulos Remessa </h5>
                    <button type="button" class="close" @click="closeModalTitulosRemessa" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="row mb-3">
                        <div class="col-md-12 col-12" v-if="titulos && titulos.length > 0">
                            <div class="mainbox" v-for="(item, index) in titulos" :key="index">
                                <div class="mark-gray"></div>
                                <div class="box p-2">
                                    <div class="row">
                                        <div v-if="item" class="col-auto d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list"></label>
                                            <div class="d-flex">
                                              <input-checkbox v-model="item.isChecked" :value-checked="true" :value-unchecked="false"></input-checkbox>
                                            </div>
                                        </div>
                                        <div v-if="item" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list">Documento</label>
                                            <div class="d-flex">
                                                <span class="data-list">{{ item.doc }}</span>
                                                <span v-if="item.parcela" class="data-list"> / {{ item.parcela }}</span>
                                            </div>
                                        </div>
                                        <div v-if="item" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list">Data Emissão</label>
                                            <span class="data-list">{{ item.data | formatData }}</span>
                                        </div>
                                        <div v-if="item" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list">Data Vencimento</label>
                                            <span class="data-list">{{ item.dtv | formatData }}</span>
                                        </div>
                                        <div v-if="item" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list">Nome</label>
                                            <span class="data-list">{{ item.nome }}</span>
                                        </div>
                                        <div v-if="item" class="col-lg-2 col-md-2 col-3 d-flex flex-column">
                                            <label v-if="index==0" class="lbl-list">Valor do Documento</label>
                                            <span class="data-list">{{ item.vlr | formatValue(2) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nb-modal-scrollable-footer">
                        <v-button label="Remover" title="Remover" danger="true" @click="handleRemoverTituloRemessa"></v-button>
                        <v-button ref="btnClose" label="Fechar" title="" @click="closeModalTitulosRemessa"></v-button>
                    </div>
                </div>
            </div>
        </div>


        <customer-form v-if="showFormPart" :crud="crud" :index="codpart" @closeform="closeFormPart"></customer-form>

        <financeiro-form v-if="showFormFin" :tipo="'R'" :crud="crud" :index="codfin" @closeform="closeFormFin"></financeiro-form>

    </div>
</template>


<style>
.total strong {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/forms/receber-list.vue